module.exports = __webpack_public_path__ + "img/127.17cf2138.jpg";